import React, {useState, useEffect } from "react";
import Header from "../Component/Header";
import { Link } from "react-router-dom";
import { getCircular } from "../Service/Api";
const VendorRegistration = () => {
  const [vendorData,setVendorData] = useState([])
  useEffect(() => {
    document.title = "Vendor Registration -  The Air Force School Subroto Park";
    async function vendorFetchData (){
      try {
        
        let await_vendor_data_await = await getCircular()
        let await_vendor_data_await_filter  = await_vendor_data_await.filter((i)=>i.category === "Vendor")
        setVendorData(await_vendor_data_await_filter)
        

      } catch (error) {
        console.error(error.message)
      }

    }
    vendorFetchData()
  }, []);


  function renderVendorData (x){
 return   x.map((i)=>{
        return(
          <>
            <div className="col-xl-4 col-lg-6 col-md-6">
            <div className="linktab" >
               
                <Link
                  to={i.url?.length > 0 ? i.url : `https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com${i.attachments?.[0]}`}
                  target="_blank"
                >
                  <div dangerouslySetInnerHTML={{ __html: i.title }} />
                  
                </Link>
              </div>
            </div>
          </>
        )
    })
       
  
  }
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>
          </li>
          <li> Vendor Registration</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1> Vendor Registration </h1>
            </div>
          </div>
             <div className="linktab" style={{width:"fit-content",margin: "auto"}}>
               
                <Link
                  to="https://docs.google.com/forms/d/e/1FAIpQLSde0hEu9MFZJPWTvyFIQpdPg7UWafWxsLwz8HKDopaGGQpCuQ/viewform"
                  target="_blank"
                >
                 
                  Click here to register - VENDOR REGISTRATION FORM
                </Link>
              </div>
              <hr/>
          <div className="row mt-5">

         {  renderVendorData(vendorData)}
          </div>
        </div>
      </div>
    </>
  );
};

export default VendorRegistration;
